import React, { FC, useEffect } from 'react';

import { fetchPullRepositorys} from '../../../redux/slices/RepositorysSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/store/store';




const TableDetailGroup = () => {
  const dispatch = useAppDispatch();

  const paging = useAppSelector(state => state.RepositorysSlice.paging)
  const result2 = useAppSelector(state => state.RepositorysSlice.results)
  useEffect(() => {
        
    // dispatch(fetchPullRepositorys())
   
}, [])
return (
  <div className="pds-dataTable pds-datatable-hoverable-rows">
 <div className="pds-dataTable-header">
    <p aria-hidden="true" className="pds-dataTable-title"><h2>Miembros del Grupo1</h2></p>
    <div className="pds-searchInput pds-dataTable-smart-search">
      <input aria-label="Filter table data search bar" className="search inputSearch pds-input-small" type="search" placeholder="Buscar Miembros del Grupo" />
      <button type="submit" aria-label="Search" aria-disabled="true" />
    </div>
  </div>
  <div className="pds-dataTable-table-container pds-table-scrolling ">
    <table className="pds-table-container pds-table pds-table-bordered pds-table-hoverable-rows" id="pds-datatable-hoverable-rows-example" aria-live="polite">
      <caption className="sr-only">Mantenedor de Grupo de Usuarios</caption>
      <thead>
        <tr>
          <th className="sort pds-dataTable-table-header" scope="col"><span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>&nbsp;Nombre de Usuario
   </span></th>
          <th className="sort pds-dataTable-table-header" scope="col" style={{maxWidth: 100, alignContent: 'left'}}><span className="pds-link-icon">
     <i data-feather="edit" aria-hidden="true" data-size="30"></i>&nbsp;Action
   </span></th>
        </tr>
      </thead>
      <tbody>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Juan Pablo Jorquera Diaz
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Ignacio Galleguillos
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Gabriel Araya
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Claudio Valdes
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Juan Perez 
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Michael Perez
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Juan Perez Perez
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Juan Perez Jackson
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   John Doe
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Juan Carlos Perez
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Michael Jordan
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
        <tr>
        <td className="pds-dataTable-table-item"><a href="#" className="pds-link-icon-left">
   <span className="pds-link-icon">
     <i data-feather="user" aria-hidden="true" data-size="30"></i>
   </span>
   Tom Cruise
 </a>
</td>
    <td className="pds-dataTable-table-item"><a href="#" className="pds-button pds-button-primary pds-button-icon-left">
    <i data-feather='trash-2' aria-hidden='true'></i>Eliminar del Grupo</a></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div className="pds-dataTable-footer">
    <div className="pds-dataTable-show-entries">
      <label className="pds-dataTable-select-label" />
      <div className="pds-select">
        <select id='' aria-label="Number of rows to display in table" name="entries" className="pds-dataTable-select-options pds-select-small">
          <option value={10} selected>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      <p className="pds-dataTable-total-entries" />
    </div>
    <nav aria-label="Pagination" className="pds-pagination pds-dataTable-pagination">
      <span className="pds-dataTable-previous-buttons pds-dataTable-disable-pagination-buttons">
        <a href="#" role="link" tabIndex={0} aria-label="first page" aria-disabled="true" className="pds-dataTable-first-page pds-pagination-fly-first page disabled" />
        <a href="#" role="link" tabIndex={0} aria-label="Previous page" aria-disabled="true" className="pds-dataTable-previous pds-pagination-step-forward page disabled" />
      </span>
      <ul className="pagination" />
      <span className="pds-dataTable-next-buttons">
        <a href="#" role="link" tabIndex={0} aria-label="Next page" className="pds-dataTable-next pds-pagination-step-backward page" />
        <a href="#" role="link" tabIndex={0} aria-label="Last page" className="pds-dataTable-last-page pds-pagination-fly-last page" />
      </span>
    </nav>
  </div>
</div>
   );
}


export default TableDetailGroup;